import React from 'react';

const HighlightSection = () => {
  return (
    <section className="highlight-section">
      <div className="highlight-container">
        <div className="highlight-content">
          <h2 className="highlight-text">
            PREMIUM HRANA<br />
            <span className="highlight-accent">POZIVA NA</span><br />
            PREMIUM OBROKE
          </h2>
        </div>
        <div className="highlight-decoration">
          <div className="highlight-line left"></div>
          <div className="highlight-diamond"></div>
          <div className="highlight-line right"></div>
        </div>
      </div>
    </section>
  );
};

export default HighlightSection;
